export const Fetch_API = 'https://johan-happythoughts.herokuapp.com/thoughts'
export const like_url = (thoughtsID) => `https://johan-happythoughts.herokuapp.com/thoughts/${thoughtsID}/likes`

